var ToggleDropdown = $.extend({/* ToggleDropdown */}, BaseComponent, {

	componentSelector: '.toggle-dropdown',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).find('.trigger-dropdown').find('.more').click((function(event) {

			$(event.currentTarget).parents('.toggle-dropdown').find('.items').slideDown(500);

			$(event.currentTarget).removeClass('active');
			$(event.currentTarget).parents('.trigger-dropdown').find('.less').addClass('active');

			Utils.scrollTo($(event.currentTarget).parents('.toggle-dropdown').offset().top);

		}).bind(this));

		$(element).find('.trigger-dropdown').find('.less').click((function(event) {

			$(event.currentTarget).parents('.toggle-dropdown').find('.items').slideUp(500);

			$(event.currentTarget).removeClass('active');
			$(event.currentTarget).parents('.trigger-dropdown').find('.more').addClass('active');

			Utils.scrollTo($(event.currentTarget).parents('.toggle-dropdown').offset().top);

		}).bind(this));
	},

})